export const STATUS = {
  ENABLED  : 'enabled',
  DISABLED : 'disabled'
}
